import { api } from "./api";

export interface PestControlData {
  PestControlId: number;
  MallId: number;
  TenantId: number;
  TenantName: string;
  Month: number;
  Year: number;
  VendorName: string;
  VendorPhone: string;
  ControlOn: string;
  Notes: string | null;
  Status: number;
}

export interface GetPestControlResponse {
  pestControlDatas: PestControlData[];
}

export const GetPestControl = async (
  pestcontrolid: number,
  mallid: number,
  tenantid: number,
  year: number,
  month: number
) => {
  try {
    const url = `/tenant/v1/getpestcontrol?pestcontrolid=${pestcontrolid}&mallid=${mallid}&tenantid=${tenantid}&year=${year}&month=${month}`;
    const response = await api.get<GetPestControlResponse>(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const SavePestControl = async (data: {
  PestControlId: number;
  MallId: number;  
  Month: number;
  Year: number;
  VendorName: string;
  VendorPhone: string;
  ControlOn: string;
  Notes: string | null;
  Status: number;
}) => {
  try {
    const url = `/tenant/v1/savepestcontrol`;

    const payload = {
      pestControlData: {
        PestControlId: data.PestControlId,
        MallId: data.MallId,  
        TenantId: 0,
        TenantName: "",
        Month: data.Month,
        Year: data.Year,
        VendorName: data.VendorName,
        VendorPhone: data.VendorPhone,
        ControlOn: data.ControlOn,
        Notes: data.Notes,
        Status: data.Status,
      },
    };

    const response = await api.post(url, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const DeletePestControl = async (pestcontrolid: number) => {
  try {
    const url = `/tenant/v1/deletepestcontrol/${pestcontrolid}`;
    const response = await api.delete(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};